import React from 'react';
import { withAnalytics } from '../../../common/analytics';
import { onAdvancedSearchSelected } from '../../../common/analytics/events';
import { messages } from '../../../messages';
import { useIntl } from 'react-intl-next';
import { GetDefaultFooter } from '../../product-router/product/result-provider/result-renderer/default-footer';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
export const JiraAdvancedSearchLinks = props => {
  const {
    formatMessage
  } = useIntl();
  const searchFooterLabel = formatMessage(getBooleanFF('platform.sea-1592-rename-advanced-search') ? messages.jira_view_all_issues_new : messages.jira_view_all_issues);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GetDefaultFooter, {
    linkComponent: props.linkComponent,
    productState: props.productState,
    searchFooterLabel: searchFooterLabel
  }));
};
export const JiraAdvancedSearch = withAnalytics({
  advancedSearchSelected: onAdvancedSearchSelected
})(JiraAdvancedSearchLinks);
export default JiraAdvancedSearch;